import { db } from "./index.js";

import { getFarmIdFromUrl } from "../utils.js";

export async function putSanitationForm(form) {
  return await db.sanitationForms.put({
    ...form,
    id: Number(form.id),
    farm_id: Number(form.farm_id),
  });
}

export async function getSanitationForms(farmId = null) {
  const currentFarmId = Number(
    farmId ?? getFarmIdFromUrl(window.location.pathname),
  );

  return await db.sanitationForms
    .filter((form) => Number(form.farm_id) === currentFarmId)
    .toArray();
}

export async function getSanitationForm(id) {
  return await db.sanitationForms.get(id);
}

export async function deleteSanitationForm(id) {
  return await db.sanitationForms.delete(id);
}
